import { baseApi } from './baseApi';

const appointmentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppointment: builder.query({
      query: () => ({
        url: '/appointment/all',
        method: 'GET',
      }),
      providesTags: ['appointment'],
    }),
    getSingleAppointment: builder.query({
      query: (id: string) => ({
        url: `/appointment/${id}`,
        method: 'GET',
      }),
      providesTags: ['appointment'],
    }),
    createAppointment: builder.mutation({
      query: (data) => ({
        url: '/appointment/create',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['appointment'],
    }),
    updateAppointment: builder.mutation({
      query: ({ id, data }: { id: string; data: any }) => ({
        url: `/appointment/${id}`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: ['appointment'],
    }),
    deleteAppointment: builder.mutation({
      query: (id: string) => ({
        url: `/appointment/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['appointment'],
    }),
  }),
});

export const {
  useGetAppointmentQuery,
  useGetSingleAppointmentQuery,
  useCreateAppointmentMutation,
  useUpdateAppointmentMutation,
  useDeleteAppointmentMutation,
} = appointmentApi;
